import React, { useState, useEffect, useContext, use } from "react";

import "../../assets/css/article/ArticleCreate.css";
import useGroupeCategorie from "../../hooks/useGroupeCategorie";
import useCategorie from "../../hooks/useCategorie";
import useArticles from "../../hooks/useArticle.js";
import useStripePaiement from "../../hooks/useStripePaiement";
import { AuthContext } from "../../contexts/AuthContext.js";

import { BOOTSTRAP_ICONS } from "../../utils/bootstrapIcons";
import { steps } from "../../constant/stepArticleCreate";
import { useNavigate } from "react-router-dom";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

import ArticleCreateStep1 from "../../components/article/ArticleCreateStep1.jsx"; //step = 0
import ArticleCreateStep2 from "../../components/article/ArticleCreateStep2.jsx"; //step = 1
import ArticleCreateStep3 from "../../components/article/ArticleCreateStep3.jsx"; //step = 2
import ArticleCreateStep4 from "../../components/article/ArticleCreateStep4.jsx"; //step = 3
import ArticleCreateStep5 from "../../components/article/ArticleCreateStep5.jsx"; //step = 4

import { validateField, isButtonDisabled } from "../../utils/validators";

import OrangeMoneyModal from "../../components/payment/OrangeMoneyModal.jsx";

const ArticleCreate = ({ setAlert }) => {
  const { user } = useContext(AuthContext);
  const [formArticle, setFormArticle] = useState({
    idUtilisateur: "",
    idCategorie: "",
    photos: [],
    oldPhotos: [],
    titre: "",
    pseudo: "",
    email: "",
    description: "",
    prix: 0,
    ville: "",
    quartier: "",
    phone: "",
    status: 2,
    archive: 2,
    etat: 2,
    typeAbonnement: 2,
    typeOffre: 1,
    dateExpiration: new Date().toISOString().substring(0, 10),
    adminApprouved: 2,
    isTest: user.typeCompte == 3 ? 1 : 2,
  });
  const [fieldErrors, setfieldErrors] = useState({
    titre: false,
    pseudo: false,
  });
  const [allChampValide, setAllChampValide] = useState(true);
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const [categoriGroup, setCategoriGroup] = useState([]);
  const [infoCle, setInfoCle] = useState([]);
  const [loadingArticle, setLoadingArticle] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [amount, setAmount] = useState(0);
  const [prixFinal, setPrixFinal] = useState(amount);
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [infoValue, setInfoValue] = useState("");
  const [step, setStep] = useState(0);
  const [paymentMethods, setPaymentMethods] = useState("mvola");
  const [formPaiement, setFormpaiement] = useState({
    paymentDetail: "",
  });
  const [isFree, setIsFree] = useState(process.env.REACT_APP_IS_FREE);
  const { getAllGroupCategories } = useGroupeCategorie();
  const [photos, setPhotos] = useState([]);
  const [showIconPicker, setShowIconPicker] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hasPrice, setHasPrice] = useState(1);
  const [phoneError, setPhoneError] = useState("");
  const [validePhoneNumber, setValidePhoneNumber] = useState(false);
  const [remise, setRemise] = useState(0);
  const [couponValue, setCouponValue] = useState(null);
  const getVisibleCount = () => {
    const width = window.innerWidth;

    if (width >= 992) return 3; // Desktop
    if (width >= 577) return 2; // Tablette
    return 1; // Mobile
  };
  const [visibleCount, setVisibleCount] = useState(getVisibleCount());

  const { getAllCategories } = useCategorie();
  const { createArticle, findLatestArticleByUser } = useArticles();

  const { createPaiement } = useStripePaiement();

  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();
  const [orangeModal, setOrangeModal] = useState({
    open: false,
    url: null,
    orderId: null,
  });
  const [paiementStatus, setPaiementStatus] = useState(null); // "success" | "failed" | null
  const [validePhoneNumberInfo, setValidePhoneNumberInfo] = useState(true);

  useEffect(() => {
    const onResize = () => {
      setVisibleCount(getVisibleCount());
      setCurrentIndex(0);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (user && user._id) {
        try {
          const res = await findLatestArticleByUser(user._id);
          const latestArticle = res?.data?.data || res;

          if (latestArticle && latestArticle.pseudo) {
            setFormArticle((prev) => ({
              ...prev,
              pseudo: latestArticle.pseudo || "",
            }));
          }
        } catch (err) {
          console.error("Error fetching latest article:", err);
        }
      }
    };

    fetchData();
  }, [user]);

  useEffect(() => {
    setIsLoading(true);
    getAllCategories()
      .then((res) => {
        if (res?.data?.data && res?.data?.data.length > 0) {
          setCategories(res.data.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });

    getAllGroupCategories()
      .then((res) => {
        if (res?.data?.data && res?.data?.data.length > 0) {
          // Recuperer les groupes de catégories qui a le status archive = 1 (actif)
          const activeGroups = res.data.data.filter(
            (group) => group.archive === 2,
          );
          setCategoriGroup(activeGroups);
        }
      })
      .catch((err) => {
        console.log(err);
        setAlert?.({
          message:
            "Une erreur s'est produite lors de la récupération des données.",
          type: "danger",
        });
      });
  }, []);

  const handleChange = (e) =>
    setFormArticle({ ...formArticle, [e.target.name]: e.target.value });

  const handlePhotos = (e) => {
    const files = Array.from(e.target.files);
    const newPhotos = files.map((file) => ({
      file,
      url: URL.createObjectURL(file),
      rotation: 0,
    }));
    setPhotos((prev) => [...prev, ...newPhotos].slice(0, 10));
  };

  const loadImage = (src) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });

  const rotateFileWithCanvas = async (fileOrBlobUrl, originalFile, degrees) => {
    const img = await loadImage(fileOrBlobUrl);

    const angle = ((degrees % 360) + 360) % 360; // sécurité
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // Pour 90° / 270°, largeur/hauteur inversées
    const swap = angle === 90 || angle === 270;
    canvas.width = swap ? img.height : img.width;
    canvas.height = swap ? img.width : img.height;

    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate((angle * Math.PI) / 180);
    ctx.drawImage(img, -img.width / 2, -img.height / 2);

    const blob = await new Promise((resolve) =>
      canvas.toBlob(resolve, originalFile.type || "image/jpeg", 0.92),
    );

    // Nouveau fichier “réellement” tourné
    const rotatedFile = new File([blob], originalFile.name, {
      type: originalFile.type || "image/jpeg",
      lastModified: Date.now(),
    });

    return rotatedFile;
  };

  const rotatePhoto = async (index, step = 90) => {
    const current = photos[index];
    if (!current) return;

    // Normalise step et l’angle (supporte -90)
    const normalizedStep = ((step % 360) + 360) % 360; // -90 -> 270 (équivalent)
    const nextAngle = ((((current.rotation || 0) + step) % 360) + 360) % 360;

    const rotatedFile = await rotateFileWithCanvas(
      current.url,
      current.file,
      step, // tu peux aussi passer normalizedStep si tu préfères
    );

    const newUrl = URL.createObjectURL(rotatedFile);

    setPhotos((prev) =>
      prev.map((p, i) => {
        if (i !== index) return p;
        try {
          URL.revokeObjectURL(p.url);
        } catch {}
        return {
          ...p,
          file: rotatedFile,
          url: newUrl,
          rotation: 0, // baked => pas besoin de transform
        };
      }),
    );
  };

  const removePhoto = (index) =>
    setPhotos((prev) => prev.filter((_, i) => i !== index));

  const movePhoto = (index, direction) => {
    const newPhotos = [...photos];
    const newPos = index + direction;
    if (newPos < 0 || newPos >= photos.length) return;
    [newPhotos[index], newPhotos[newPos]] = [
      newPhotos[newPos],
      newPhotos[index],
    ];
    setPhotos(newPhotos);
  };

  const isStepDisabled = () => {
    if (step === 0)
      return (
        !formArticle.idCategorie ||
        !formArticle.pseudo ||
        !formArticle.titre ||
        !formArticle.description ||
        (hasPrice == 1 &&
          (!formArticle.prix ||
            isNaN(Number(formArticle.prix)) ||
            Number(formArticle.prix) <= 0)) ||
        photos.length === 0
      );

    if (step === 1)
      return (
        !formArticle.ville ||
        !formArticle.quartier ||
        !formArticle.email ||
        !formArticle.phone
      );
    // if (step === 3) return !paymentMethod || !formPaiement.paymentDetail;
    if (step === 3) return false;
    return false;
  };

  const addInfoCle = () => {
    if (!selectedIcon || !infoValue) return;

    setInfoCle((prev) => [
      ...prev,
      {
        name: selectedIcon.label,
        value: infoValue,
        icon: selectedIcon.icon,
      },
    ]);

    setSelectedIcon(null);
    setInfoValue("");
  };

  const removeInfoCle = (index) => {
    setInfoCle((prev) => prev.filter((_, i) => i !== index));
  };

  const next = () => {
    setStep((s) => Math.min(s + 1, 4));
  };
  const prev = () => setStep((s) => Math.max(s - 1, 0));

  const handleSubmit = async () => {
    if (step === 3) {
      setLoadingArticle(true);
      const dataToSend = {
        ...formArticle,
        idUtilisateur: user._id,
        photos: photos.map((p) => p.file),
        infoCle: infoCle,
      };
      const fd = new FormData();
      Object.keys(dataToSend).forEach((key) => {
        if (key !== "photos" && key !== "oldPhotos") {
          if (typeof dataToSend[key] === "object") {
            fd.append(key, JSON.stringify(dataToSend[key]));
          } else {
            fd.append(key, dataToSend[key]);
          }
        }
      });
      dataToSend.photos.forEach((p) => fd.append("photos", p));
      fd.append("existingPhotos", JSON.stringify(dataToSend.oldPhotos || []));

      const methodePaiment =
        paymentMethods == "cb"
          ? "stripe"
          : paymentMethods == "mvola"
            ? "mvola"
            : paymentMethods == "orange"
              ? "orange"
              : "airtel";

      const paymentValue =
        methodePaiment === "mvola"
          ? 1
          : methodePaiment === "orange"
            ? 2
            : methodePaiment === "airtel"
              ? 3
              : 4;

      let paymentMethodStripe = null;

      if (isFree != 1 && prixFinal != 0) {
        if (paymentMethods === "cb") {
          const { paymentMethod, error } = await stripe.createPaymentMethod({
            type: "card",
            card: elements.getElement(CardElement),
          });
          paymentMethodStripe = paymentMethod;
          if (error) {
            console.error(error);
            setAlert({
              message:
                error.message || "Une erreur s'est produite lors du paiement.",
              type: "danger",
            });
            setLoadingArticle(false);
            return;
          }
        }
      }

      await createArticle(fd, setAlert)
        .then(async (res) => {
          const createdArticle = res?.data?.data || res?.data || res;

          await createPaiement(
            {
              methodPayment:
                paymentMethods == "cb"
                  ? 4
                  : paymentMethods == "mvola"
                    ? 1
                    : paymentMethods == "orange"
                      ? 2
                      : 3,
              paymentMethodId: paymentMethodStripe?.id || null,
              idArticle: createdArticle?._id,
              amount: isFree == 1 || prixFinal == 0 ? 0 : prixFinal,
              idUser: user?._id,
              type: 1,
              devise: "MGA",
              phone: formPaiement.paymentDetail || "",
              coupon: couponValue || "",
              amountInitial: amount, // le montant AVANT réduction (state `amount`, déjà présent dans le composant)
              amountRemise: remise || 0,
            },
            isFree == 1 || prixFinal == 0 ? "gratuit" : methodePaiment,
          )
            .then(async (paiementRes) => {
              // Cas Orange Money : redirection vers la page de paiement
              if (methodePaiment === "orange") {
                const paymentUrl =
                  paiementRes?.data?.payment_url || paiementRes?.payment_url;
                const orderId =
                  paiementRes?.data?.orderId || paiementRes?.orderId;

                if (prixFinal == 0) {
                  setAlert?.({
                    message:
                      isFree == 1 || prixFinal == 0
                        ? "Votre annonce a été publiée !"
                        : "En attente de validation du paiement. Veuillez patientez!",
                    type: "success",
                  });
                  setLoadingArticle(false);
                  navigate("/article/succes");
                  return;
                }
                if (paymentUrl) {
                  setLoadingArticle(false);
                  setOrangeModal({ open: true, url: paymentUrl, orderId });
                  return;
                } else {
                  setLoadingArticle(false);
                  setAlert?.({
                    message:
                      "Impossible de récupérer le lien de paiement Orange Money.",
                    type: "danger",
                  });
                  return;
                }
              }

              // Cas gratuit / mvola / stripe / airtel : comportement existant
              setAlert?.({
                message:
                  isFree == 1 || prixFinal == 0
                    ? "Votre annonce a été publiée !"
                    : "En attente de validation du paiement. Veuillez patientez!",
                type: "success",
              });
              setLoadingArticle(false);
              navigate("/article/succes");
            })
            .catch((err) => {
              setLoadingArticle(false);
              setAlert?.({
                message: "Une erreur s'est produite!",
                type: "danger",
              });
            });
        })
        .catch((err) => {
          const messageError = err?.response?.data?.error
            ? err?.response?.data?.error
            : "Erreur lors de l'enregistrement!";
          setLoadingArticle(false);
          setAlert?.({
            message: messageError,
            type: "danger",
          });
        });
    } else {
      next();
    }
  };

  const onCouponChange = (newPrixFinal) => {
    setPrixFinal(newPrixFinal);
  };
  return (
    <div className="container all_content_article_create">
      <i
        class="bi bi-x-circle login_icon_x"
        role="button"
        onClick={() => navigate("/")}
      ></i>
      <div className="article_create_header">
        <h1 className="article_create_title">Créez votre annonce</h1>
      </div>

      <div className="article_create_stepper">
        {steps.map((s, i) => {
          const isMobile = window.innerWidth <= 480;

          // Mobile : afficher step courant, précédent et suivant
          if (isMobile && i !== step && i !== step - 1 && i !== step + 1) {
            return null;
          }

          return (
            <div
              key={i}
              className={`article_create_step_item ${
                i === step ? "active" : i < step ? "completed" : ""
              }`}
            >
              <div className="article_create_step_circle">{i + 1}</div>
              <span className="article_create_step_label">{s}</span>
            </div>
          );
        })}
      </div>

      <div className="article_create_content">
        {step === 0 && (
          <ArticleCreateStep1
            formArticle={formArticle}
            photos={photos}
            handleChange={handleChange}
            categories={categories}
            movePhoto={movePhoto}
            removePhoto={removePhoto}
            handlePhotos={handlePhotos}
            rotatePhoto={rotatePhoto}
            amount={amount}
            setAmount={setAmount}
            categoriGroup={categoriGroup}
            setSelectedGroupId={setSelectedGroupId}
            selectedGroupId={selectedGroupId}
            setHasPrice={setHasPrice}
            hasPrice={hasPrice}
            validateField={validateField}
            setfieldErrors={setfieldErrors}
            fieldErrors={fieldErrors}
          />
        )}
        {step === 1 && (
          <ArticleCreateStep2
            setShowIconPicker={setShowIconPicker}
            showIconPicker={showIconPicker}
            BOOTSTRAP_ICONS={BOOTSTRAP_ICONS}
            selectedIcon={selectedIcon}
            setSelectedIcon={setSelectedIcon}
            infoValue={infoValue}
            setInfoValue={setInfoValue}
            addInfoCle={addInfoCle}
            infoCle={infoCle}
            removeInfoCle={removeInfoCle}
            formArticle={formArticle}
            handleChange={handleChange}
            phoneError={phoneError}
            setPhoneError={setPhoneError}
            validePhoneNumberInfo={validePhoneNumberInfo}
            setValidePhoneNumberInfo={setValidePhoneNumberInfo}
          />
        )}
        {step === 2 && (
          <ArticleCreateStep3
            photos={photos}
            visibleCount={visibleCount}
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
            formArticle={formArticle}
            infoCle={infoCle}
            next={next}
            prev={prev}
            handleChange={handleChange}
            user={user}
          />
        )}
        {step === 3 && (
          <ArticleCreateStep4
            paymentMethods={paymentMethods}
            setPaymentMethods={setPaymentMethods}
            setFormpaiement={setFormpaiement}
            formPaiement={formPaiement}
            amount={isFree == 1 ? 0 : amount}
            prixFinal={prixFinal}
            setPrixFinal={setPrixFinal}
            isFree={isFree}
            validePhoneNumber={validePhoneNumber}
            setValidePhoneNumber={setValidePhoneNumber}
            onCouponChange={onCouponChange}
            couponValue={couponValue}
            setCouponValue={setCouponValue}
            remise={remise}
            setRemise={setRemise}
            userId={user?._id} // ← ajouté
            categorieId={selectedGroupId}
          />
        )}
        {step === 4 && <ArticleCreateStep5 status={paiementStatus} />}
      </div>
      {step < 4 && step !== 2 && (
        <div className="article_create_footer">
          {step > 0 && (
            <button className="article_create_btn_retour" onClick={prev}>
              Retour
            </button>
          )}
          <button
            className={`article_create_btn_continuer ${
              (step === 3 && validePhoneNumber === false) ||
              isStepDisabled() ||
              loadingArticle ||
              isButtonDisabled(fieldErrors) ||
              validePhoneNumberInfo == false
                ? "disabled"
                : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleSubmit();
            }}
            // disabled={isStepDisabled() || loadingArticle}
            disabled={
              (step === 3 && validePhoneNumber === false) ||
              isStepDisabled() ||
              loadingArticle ||
              isButtonDisabled(fieldErrors) ||
              validePhoneNumberInfo == false
            }
          >
            {loadingArticle ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
                style={{ color: "var(--couleur-principale)" }}
              ></span>
            ) : step === 3 ? (
              "PAYER & PUBLIER"
            ) : (
              "Continuer"
            )}
          </button>
        </div>
      )}

      {orangeModal.open && (
        <OrangeMoneyModal
          paymentUrl={orangeModal.url}
          orderId={orangeModal.orderId}
          onSuccess={() => {
            setOrangeModal({ open: false, url: null, orderId: null });
            setPaiementStatus("success");
            setStep(4);
          }}
          onFailure={() => {
            setOrangeModal({ open: false, url: null, orderId: null });
            setPaiementStatus("failed");
            setStep(4);
          }}
          onClose={() =>
            setOrangeModal({ open: false, url: null, orderId: null })
          }
        />
      )}
    </div>
  );
};

export default ArticleCreate;
